export const nftsBaseUrl = '/nfts'
